import React from "react";
import PropTypes from "kf-proptypes/widgets";

import styles from "./notes.css";

export const NOTES_SIZE = {
  SMALL: "small",
  MEDIUM: "medium"
};

export const NOTES_TYPES = {
  INFO: "info",
  ERROR: "error"
};

export function Notes(props) {
  const { title, type, size, children } = props;

  return (
    <div
      className={`${styles.notes} ${styles[type]} ${styles[size]}`}
      data-component="notes"
    >
      {title && <span className={`${styles.title}`}>{title}</span>}
      {children && <span className={`${styles.content}`}>{children}</span>}
    </div>
  );
}

Notes.propTypes = {
  /** The title of the note. */
  title: PropTypes.node,
  /** The Note Type either it can be Info (blue) or Error (red) */
  type: PropTypes.oneOf([NOTES_TYPES.INFO, NOTES_TYPES.ERROR]),
  /**  Size of the note (Small or Medium) */
  size: PropTypes.oneOf([NOTES_SIZE.SMALL, NOTES_SIZE.MEDIUM]),
  /** Note as a React Node. */
  children: PropTypes.node
};

Notes.defaultProps = {
  type: NOTES_TYPES.INFO,
  size: NOTES_SIZE.SMALL
};
